import { PayStatement } from "@wingspanhq/wingspan-api-sdk";

import { parsePayrollAmount } from "../../PayrollRuns/utils";

/** Computed totals, not an API shape — v3 exposes only the raw amounts below. */
export type PaystubPayBreakdown = {
  grossAmount: number;
  netAmount: number;
  taxes: number;
  benefits: number;
};

/**
 * The gross → net breakdown shown on the payee's "Recent pay" card.
 *
 * `taxes` is the statement's total worker tax withheld; `benefits` is the
 * residual of every other deduction (gross − net − taxes) so the breakdown
 * reconciles to net pay — the v3 pay statement does not model pre-tax benefit
 * deductions as their own line.
 */
export const selectorPaystubPayBreakdown = (
  payStatement: PayStatement
): PaystubPayBreakdown => {
  const { amountDetails } = payStatement;
  const grossAmount = parsePayrollAmount(amountDetails?.grossPay);
  const netAmount = parsePayrollAmount(amountDetails?.netPay);
  const taxes = parsePayrollAmount(amountDetails?.taxWithheld);

  return {
    grossAmount,
    netAmount,
    taxes,
    benefits: Math.max(grossAmount - netAmount - taxes, 0)
  };
};
